import {Fade} from '@aboutyou/transitions';
import React from 'react';
import styled from 'styled-components';
import {AboutYouLogo} from '../../features/AboutYouLogo/AboutYouLogo';

export const OffcanvasAboutNameLogo = () => {
  return (
    <Container>
      <AboutYouLogo
        disableSvgLogo
        disableWoohoo
        disableBasCampaignTakeover
        disableAYAnniversaryCampaign
        testId="OffcanvasAboutYouLogo"
        firstNameMaxLength={15}
        FirstNameAnimationComponent={Fade}
      />
    </Container>
  );
};

const Container = styled.div`
  padding-top: 10px;
`;
